module.exports = __webpack_public_path__ + "static/media/no_image.92793810.jpg";